/**
 * Acorta un id/uuid crudo para usarlo SOLO como último recurso cuando no se pudo resolver el
 * nombre legible de la entidad ("ab12cd34…"). NUNCA exponemos el UUID/sub completo en la UI;
 * cuando lo usamos como fallback, va acortado y siempre etiquetado por el caller ("Grupo: ab12cd34…").
 *
 * Ver docs/CONVENCIONES_FRONTEND.md — "Regla anti-UUID en UI".
 */
export function shortId(id: string): string {
    return id.length > 8 ? `${id.slice(0, 8)}…` : id;
}
